import { useNavigate, useOutletContext } from 'react-router-dom'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import { RouteContextParams } from 'modules/expenses/lib/RouteContextParams'
import { isMyExpensesSection } from 'modules/expenses/lib/common'
import { ExportSidepanel } from 'modules/universal_exports/components/ExportSidepanel'
import { useExporter } from 'modules/universal_exports/hooks/useExporter'

type OverrideFilters = Record<string, Array<number | string | boolean>>
const ExporterPage = () => {
  const resource = 'expenses.expensable'

  const navigate = useNavigate()
  const { back, section } = useOutletContext<RouteContextParams>()
  const { company } = useCurrentSession()
  const { employee } = useCurrentSession()

  const { filters } = useExporter({ resource: resource, companyId: company.id })
  const hasReportedByFilter = filters.some((filter) => filter.name === 'reported_by')
  const overrideOwner: OverrideFilters = employee?.id ? { owner: [employee.id] } : {}

  const overrideFilters: OverrideFilters = isMyExpensesSection(section)
    ? hasReportedByFilter
      ? { reported_by: ['me'] }
      : overrideOwner
    : {}

  return (
    <ExportSidepanel
      resource={resource}
      overrideFilters={overrideFilters}
      onClose={() => navigate(back.href)}
    />
  )
}

export default ExporterPage
